module.exports = __webpack_public_path__ + "img/face-smile-halo.93b441be.svg";